



<template>
  <div class="mt-2">
    <FormPdfGenerate />
  </div>
 
</template>

<script>
import actions from "@/assets/utils/utils";
import { BootstrapVue } from 'bootstrap-vue';
import { FormPdfGenerate } from '../components';

export default {
  name : "ArchivoPdf",


  components: {
    ...BootstrapVue.components,
    FormPdfGenerate
  },

  mounted() {
    actions.setearTitulo("Generacion Archivo PDF");
  }
}
</script>
